<div class="wrapper-mini text-center auth-form">

    <div class="header">
        <h1>Forgot password</h1>
        <p *ngIf="!successMessage">Please enter the email address associated with your account. This is where the reset email will be sent.</p>
        <p *ngIf="successMessage">{{ successMessage }}</p>
    </div>

    <div class="form-block text-left" *ngIf="!successMessage">
        <label for="email">Email</label>
        <input type="text" name="email" data-testid="input-forgot-email" [(ngModel)]="user_email">
    </div>

    <div class="footer">
        <saffron-button 
            *ngIf="!successMessage"
            text="Initiate password reset"
            data-testid="btn-initiate-password-reset"
            size="wide" 
            type="primary" 
            [is_loading]="loading"
            [is_disabled]="!isEmailValid()"
            (click)="reset()">
        </saffron-button>

        <p> 
            <a class="text-color-primary" data-testid="link-back-to-login" [routerLink]="['/auth/login']">Go back to login</a>
        </p>
    </div>

</div>